module.exports = "/images/mandarin-untuk-anak.jpg?2704051d6041d755586e353b5b6cfc38";